import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { TypeHelper } from '@blade/std-lib'
import type { ServicesPoolsGetTrendingCreatePayload } from '@blade/trade-api-client'

/**
 * The trending list.
 *
 * It used to be the raid board — a promotion slot communities competed for,
 * served from its own route and its own shape. It is a market list now,
 * ranked on distinct traders and holder growth over the hour, and it comes
 * from the same place the other explore lists do.
 */
export const fetchTrendingPairsRequestAction = action(
  async (
    ctx,
    {
      network,
      ...req
    }: { network: Network.Network } & TypeHelper.OmitKey<
      ServicesPoolsGetTrendingCreatePayload,
      'network'
    >,
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesPoolsGetTrendingCreate, [
        {
          network: Network.toDto(network),
          ...req,
        },
      ]),
    )

    return pipe(result, Result.mapError(ApiError.fallbackToUnknown))
  },
  'fetchTrendingPairsRequestAction',
)
